
const env = (window as any)._env_;

const config = {
  REACT_APP_ADMIN_BASE_URL: env.REACT_APP_ADMIN_BASE_URL,
  REACT_APP_API_BASE_URL: env.REACT_APP_API_BASE_URL,
  REACT_APP_IMAGE_URL: env.REACT_APP_IMAGE_URL,
  REACT_APP_LARAVEL_APP_URL: env.REACT_APP_LARAVEL_APP_URL,
};

export default config;
